import React from "react";
import { ShieldCheck, Camera, Trash2 } from "lucide-react";
import { Reveal } from "./Reveal";
import { IMAGES } from "../../data/content";
import { useLang } from "../../i18n/LanguageContext";

const pointIcons = [Camera, Trash2, ShieldCheck];

export const Privacy = () => {
  const { t } = useLang();
  return (
    <section id="datenschutz-info" className="scroll-mt-24 py-20 lg:py-28">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="overflow-hidden rounded-[2.5rem] bg-petrol">
          <div className="grid items-center gap-10 p-8 sm:p-12 lg:grid-cols-2 lg:p-16">
            <Reveal>
              <div>
                <span className="inline-flex items-center gap-2 rounded-full bg-white/10 px-4 py-1.5 text-sm font-bold text-cream">
                  <ShieldCheck className="h-4 w-4" /> {t.privacy.badge}
                </span>
                <h2 className="mt-5 font-heading text-3xl font-extrabold tracking-tight text-cream sm:text-4xl">
                  {t.privacy.title}
                </h2>
                <p className="mt-4 text-lg leading-relaxed text-cream/70">
                  {t.privacy.subtitle}
                </p>
                <div className="mt-8 space-y-4">
                  {t.privacy.points.map((p, i) => {
                    const Icon = pointIcons[i];
                    return (
                      <div key={p.title} className="flex items-start gap-4">
                        <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-2xl bg-terracotta text-white">
                          <Icon className="h-5 w-5" strokeWidth={2} />
                        </span>
                        <div>
                          <p className="font-heading text-lg font-bold text-cream">
                            {p.title}
                          </p>
                          <p className="text-cream/65">{p.text}</p>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </Reveal>
            <Reveal delay={0.1}>
              <img
                src={IMAGES.fridge}
                alt={t.privacy.alt}
                className="w-full rounded-3xl object-cover shadow-2xl"
                style={{ aspectRatio: "4 / 3" }}
                loading="lazy"
              />
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
};
